import React from 'react';

const PluginExportsContext = React.createContext(
  {}
);
const PluginExportsContextProvider = ({ value, children }) => /* @__PURE__ */ React.createElement(PluginExportsContext.Provider, { value }, children);
const usePluginExportsContext = () => React.useContext(PluginExportsContext);

export { PluginExportsContext, PluginExportsContextProvider, usePluginExportsContext };
//# sourceMappingURL=PluginExportsContext.js.map
